const CATEGORY_TYPES = {
    1: 'Dịch Vụ',
    2: 'Dự Án',
    3: 'Văn Bản Pháp Luật',
    4: 'Tin Tức',
    5: 'Tuyển Dụng',
};

export default CATEGORY_TYPES;
